function positionAurhenMegaMenus() {
  if (window.innerWidth < 990) return;

  document
    .querySelectorAll('.menu-list__list-item[data-menu-title]')
    .forEach((menuItem) => {
      const link = menuItem.querySelector(':scope > .menu-list__link');
      const megaList = menuItem.querySelector('.mega-menu__list');

      if (!link || !megaList) return;

      // Erst zurücksetzen, damit korrekt gemessen wird
      megaList.style.transform = '';

      const linkRect = link.getBoundingClientRect();
      const listRect = megaList.getBoundingClientRect();

      // Linke Kante des Untermenüs unter die linke Kante
      // des Hauptmenüpunkts setzen
      const offset = linkRect.left - listRect.left + 10;

      megaList.style.transform = `translateX(${offset}px)`;
    });
}

function scheduleAurhenMegaMenuPosition() {
  requestAnimationFrame(() => {
    positionAurhenMegaMenus();

    // Heritage verändert das Menü nach dem Öffnen noch einmal.
    // Deshalb Position anschließend nochmals setzen.
    setTimeout(positionAurhenMegaMenus, 50);
    setTimeout(positionAurhenMegaMenus, 250);
    setTimeout(positionAurhenMegaMenus, 700);
    setTimeout(positionAurhenMegaMenus, 1200);
  });
}

function initAurhenMegaMenus() {
  scheduleAurhenMegaMenuPosition();

  window.addEventListener('resize', scheduleAurhenMegaMenuPosition);

  document.addEventListener('pointerover', (event) => {
    if (event.target.closest('.menu-list__list-item[data-menu-title]')) {
      scheduleAurhenMegaMenuPosition();
    }
  });

  document.addEventListener('focusin', (event) => {
    if (event.target.closest('.menu-list__list-item[data-menu-title]')) {
      scheduleAurhenMegaMenuPosition();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAurhenMegaMenus);
} else {
  initAurhenMegaMenus();
}